import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaArrowCircleLeft } from "react-icons/fa";

export default () => {
  return (
    <div>
<section className="detail-sec px-4">
  {/* <i className="fa-solid fa-circle-xmark text-color fs-4" /> */}
  <div className="container">
    <div className="row detail-main mt-2 shadow-sm rounded bg-light position-relative power-calendly">
      {/* <div className="position-absolute powered">
        <p className="text-uppercase text-left  fw-normal">powered by</p>
        <p className="fs-6 fw-bold mt-1">Calendly</p>
      </div> */}
      <div className="col-md-4 p-4 lining d-flex flex-column justify-content-between text-center text-md-start">
        <div>
          <div className='text-primary'>
            <Link to={"/submit-request"}>
            <FaArrowCircleLeft size={32}/>
            </Link>
            {/* <i className="fa-solid fa-arrow-left text-primary fs-5 border rounded-circle p-2" /> */}
          </div>
          <h5 className="fs-6 fw-bold lh-1 mt-2 text-secondary">Mark Letteriello</h5>
          <h1 className="fs-3 fw-bold lh-base mt-2">Rolling Adz</h1>
          <div className="d-flex align-items-baseline justify-content-center justify-content-md-start mt-2">
            <i className="fa-solid fa-clock fs-6 me-2 text-secondary" />
            <p className="fs-6 lh-base fw-bold mt-2 text-secondary ">30min</p>
          </div>
          <div className="d-flex align-items-baseline justify-content-center justify-content-md-start mt-2">
            <i className="fa-solid fa-location-dot mt-2 me-3 fs-6 text-secondary" />
            <a href="#" className="fs-6 lh-base fw-bold mt-2 text-secondary text-break">https://us02web.zoom.us/j/6982318908</a>
          </div>
          <div className="d-flex align-items-baseline justify-content-center justify-content-md-start mt-2">
            <i className="bi bi-calendar fs-6 me-2 text-secondary" />
            <p className="fs-6 lh-base fw-bold mt-2 text-secondary">10:00am - 10:30am, Thursday, November
              24,2022</p>
          </div>
          <div className="d-flex align-items-baseline justify-content-center justify-content-md-start mt-2">
            <i className="fa-solid fa-earth-americas fs-6 me-2 text-secondary" />
            <p className="fs-6 lh-base fw-bold mt-2 text-secondary">Pacific Time - US &amp; Canada</p>
          </div>
        </div>
        <div>
          <a href="#" className="text-primary align-text-bottom fs-6 fw-normal lh-base mt-1"> Cookie
            Settings</a>
        </div>
      </div>
      <div className="col-md-8 p-4">
        <h2 className="fs-4 fw-bold lh-base">Enter Details</h2>
        <form action>
          <div className="mt-2">
            <label htmlFor="name" className="fs-5 fw-normal lh-base w-100"> Name *</label>
            <input type="text" id="name" placeholder="Nike" className="bg-light mt-2 shadow-none border rounded p-2 w-75 lh-base fs-6" />
          </div>
          <div className="mt-2">
            <label htmlFor="email" className="fs-5 fw-normal lh-base w-100"> Email *</label>
            <input type="email" id="email" placeholder="support@nike.com" className="bg-light mt-2 shadow-none border rounded p-2 w-75 lh-base fs-6" />
          </div>
          <div className="add-guest mt-3">
            <button type="button" className="rounded-pill py-2 px-3 fs-6 fw-normal lh-base">Add
              Guests
              </button>
          </div>
          <div className="mt-3">
            <label htmlFor="meeting" className="w-100 fs-5 fw-normal lh-base">Please share anything that will
              help prepare for our meeting</label>
            <textarea name id="meeting" className="w-75 border mt-2 p-2 bg-light fs-6 lh-base" placeholder="campaign request (demo)" defaultValue={""} />
          </div>
          <div className="add-guest1 mt-5">
            <button type="button" className="btn btn-primary">Schedule
              Event
              </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
    </div>
  )
}
